import { gql } from 'apollo-boost'

const SCRAPING_SESSION_VALIDATION_STATES = gql`
  query scrapingSessionValidationStates($ids: [ID!]!) {
    scrapingSessionValidationStates(ids: $ids) {
      id
      validationStatus
      validatedAt
    }
  }
`

export default SCRAPING_SESSION_VALIDATION_STATES
